import { LOCALE_SUBDIRECTORY_MAPPING } from './constants';

export const getSubDirectoryLocale = (currentLocale: string): string => {
  if (!currentLocale) return '';
  const normalizedLocale = currentLocale.replace('_', '-');
  return LOCALE_SUBDIRECTORY_MAPPING[normalizedLocale] || LOCALE_SUBDIRECTORY_MAPPING[currentLocale] || '';
};
